import { createFileRoute } from '@tanstack/react-router'

import { NotesPanel } from '@/components/clients/notes-panel'
import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import { matching, readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/clients/$clientId/notes')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        /** Lot 19 (`web_path`) : la note désignée, épinglée et surlignée. */
        note: matching(/^[0-9a-f]{24}$/),
      },
      search,
    ),
  component: ClientNotesPage,
})

function ClientNotesPage() {
  const client = useShellClient()
  const { note } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <Frame>
      <NotesPanel
        client={client}
        focusId={note}
        onDismissFocus={() => {
          void navigate({ search: { note: undefined }, replace: true })
        }}
      />
    </Frame>
  )
}
